<template>
    <div class="roleAdmin">
        <div class="menuCont">
            <tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :treeToolBar="treeToolBar"
                :defaultProps="defaultProps"
                :departTotal="departTotal"
                :nodeKey="'id'"
                @handleAddTreeNode="handleAddTreeNode"
                @handleTreeNodeClick="handleTreeNodeClick"
                :btnName="btnName"
                :treeSearchBar="true"
                @searchChange="searchChange"
                :default-expand-all="true"
            >
            </tree>
        </div>
        <el-scrollbar style="height: '100%'">
            <div class="formCont">
                <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="100px"
                    :inline="true"
                >
                    <el-row>
                        <el-col :span="24">
                            <el-form-item
                                label="Role Name"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Place Input Role Name',
                                    },
                                ]"
                                prop="name"
                            >
                                <el-input
                                    clearable
                                    placeholder="Place Input Role Name"
                                    maxlength="20"
                                    size="small"
                                    v-model="addForm.name"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Remark">
                                <el-input
                                    clearable
                                    placeholder="Place Input Remark"
                                    maxlength="20"
                                    size="small"
                                    v-model="addForm.remark"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Role Type"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Place Select Role Type',
                                    },
                                ]"
                                prop="type"
                            >
                                <el-select
                                    v-model="addForm.type"
                                    placeholder="Place Select Role Type"
                                    size="small"
                                >
                                    <el-option
                                        v-for="item in typeList"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Authority">
                                <el-scrollbar style="height: 560px">
                                    <el-tree
                                        ref="treeRow"
                                        :treeLoading="treeLoading"
                                        :data="rowTreeData"
                                        show-checkbox
                                        :render-content="renderContent"
                                        :highlight-current="true"
                                        node-key="id"
                                        :props="rowTreeProps"
                                        default-expand-all
                                        :filter-node-method="filterNode"
                                        :expand-on-click-node="false"
                                        :check-on-click-node="true"
                                        @check="handleCheckChange"
                                        :default-checked-keys="
                                            addForm.authority
                                        "
                                        style="font-size: 12px"
                                    >
                                    </el-tree>
                                </el-scrollbar>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <div class="roleAdmin_bottom">
                    <el-button @click="commit" type="primary" size="small"
                        >Save</el-button
                    >
                    <el-button @click="clear" v-if="nowStatus" size="small"
                        >Empty</el-button
                    >
                    <el-button @click="del" type="danger" v-else size="small"
                        >Remove</el-button
                    >
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import tree from "@/common/components/treeChange";
export default {
    data() {
        return {
            treeData: [],
            rowTreeData: [],
            treeLoading: false,
            treeToolBar: true,
            defaultProps: {
                children: "child",
                label: "name",
            },
            rowTreeProps: {
                children: "child",
                label: "name",
            },
            btnName: "创建角色",

            addForm: {
                type: "",
            },
            nowStatus: 0,
            nowClick: "",

            typeList: [
                { key: "admin", value: "超级管理员" },
                { key: "subadmin", value: "经理" },
                { key: "leader", value: "组长" },
                { key: "staff", value: "普通员工" },
            ],
        };
    },
    components: {
        tree: tree,
    },
    methods: {
        getRoleList(name, id) {
            this.treeLoading = true;
            cmofferApi
                .role(name ? { name: name } : {}, "get", id)
                .then((res) => {
                    if (res) {
                        if (id) {
                            this.addForm = res.data;
                            this.$nextTick(() => {
                                this.$refs.treeRow.setCheckedKeys(
                                    this.addForm.authority
                                );
                            });
                        } else {
                            this.treeData = res.data;
                            this.typeList = res.data.map((item) => {
                                return { key: item.type, value: item.name };
                            });
                            console.log(this.typeList);
                            /* this.getRoleList(
                            "",
                            this.addForm.id ? this.addForm.id : res.data[0].id
                        );
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addForm.id
                                    ? this.addForm.id
                                    : res.data[0].id
                            );
                        }); */
                        }
                        this.treeLoading = false;
                    }
                });
        },
        handleAddTreeNode(sth) {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm = {
                authority: [],
                id: "",
                name: "",
                remark: "",
                type: "",
            };
            this.nowStatus = 1;
            this.nowClick = null;
            this.$nextTick(() => {
                this.$refs.myTree.$refs.tree.setCurrentKey();
                this.$refs.treeRow.setCheckedKeys(this.addForm.authority);
            });
        },
        searchChange(text) {
            this.getRoleList(text);
        },
        handleTreeNodeClick(item) {
            this.treeLoading = true;
            this.getRoleList("", item.id);
            this.nowStatus = 0;
            this.nowClick = item.id;
            /* this.$nextTick(() => {
                this.$refs.treeRow.setCheckedKeys(this.addForm.authority);
            }); */
            this.treeLoading = false;
        },
        getMenu() {
            cmofferApi.menu({}, "get").then((res) => {
                if (res) {
                    this.rowTreeData = res.data[0].child;
                }
            });
        },
        clear() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm = {
                authority: [],
                id: "",
                name: "",
                remark: "",
                type: "",
            };
        },
        del() {
            this.treeLoading = true;
            this.$confirm("Do you want to continue?", "Tip", {
                type: "warning",
            })
                .then(() => {
                    cmofferApi.role({}, "delete", this.nowClick).then((res) => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success("Delete Success");
                            }
                            this.clear();
                            this.getRoleList();
                        }
                    });
                })
        },
        //修改节点Dom
        renderContent(h, { node, data, store }) {
            let className = "";
            // perms这个是后台数据区分普通tree节点和横向tree节点的标志  各位要根据实际情况做相对应的修改
            if (node.level == 3) {
                className = "especially";
            }
            return (
                // 在需要做横向排列的模块做标记
                <div class={className}>{data.name}</div>
            );
        },
        handleCheckChange(item) {
            let arr1 = this.$refs.treeRow.getHalfCheckedKeys();
            let arr2 = this.$refs.treeRow.getCheckedKeys();
            let arr = arr1.concat(arr2);
            this.authority = arr;
        },
        // 改变tree节点样式
        changeTreeClass() {
            // 找到之前做标记的class
            var classDomList = document.getElementsByClassName("especially");

            //   改变这几个样式
            for (var i = 0; i < classDomList.length; i++) {
                classDomList[i].parentNode.style.cssText = "float: left";
                classDomList[i].parentNode.className =
                    "el-tree-node__content option-wrapper";
                classDomList[
                    i
                ].parentNode.parentNode.parentNode.style.marginLeft = "70px";
            }
        },
        // 保存提交
        commit() {
            this.handleCheckChange();
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .role(
                            {
                                // id: this.addForm.id ? this.addForm.id : "",
                                name: this.addForm.name,
                                type: this.addForm.type,
                                remark: this.addForm.remark,
                                authority: this.authority,
                            },
                            this.addForm.id ? "put" : "post",
                            this.addForm.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success("Save Success");
                                this.getRoleList();
                            }
                        });
                }
            });
        },
    },
    created() {
        this.getRoleList();
        this.getMenu();
    },
    updated() {
        this.changeTreeClass();
    },
};
</script>
<style lang="scss">
.roleAdmin {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        box-sizing: border-box;
        height: calc(100% - 10px);
        border: 1px solid #eee;
        &:hover {
            box-shadow: 2px 2px 10px #eee;
        }
    }
    .formCont {
        height: 100%;
        width: calc(100% - 250px);
        .el-col-24 {
            text-align: left;
        }
        .el-form-item__content {
            width: 700px;
        }
        .el-input {
            width: 500px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
    }
    .roleAdmin_bottom {
        text-align: left;
        margin: 80px 100px 0;
    }
    .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .option-wrapper {
        padding: 0 !important;
    }
}
</style>